export const GERENCIALES_REPORT_TYPE = 'contract_details';
export const GERENCIALES_PAYMENTS_REPORT_TYPE = 'payments-report';
export const GERENCIALES_DEBT_BALANCE_REPORT_TYPE = 'debt-balance-report';
export const GERENCIALES_DEBT_STATUS_REPORT_TYPE = 'debt-status-report';
export const GERENCIALES_PERSONAL_DATA_REPORT_TYPE = 'personal-data-report';

export const GERENCIALES_DEBT_STATUS_VIEW_TABLE = 'table';
export const GERENCIALES_DEBT_STATUS_VIEW_CHART = 'chart';

export const GERENCIALES_DATE_RANGE_REPORTS = [GERENCIALES_PAYMENTS_REPORT_TYPE];
export const GERENCIALES_PDF_REPORTS = [
  GERENCIALES_REPORT_TYPE,
  GERENCIALES_PAYMENTS_REPORT_TYPE,
  GERENCIALES_DEBT_STATUS_REPORT_TYPE,
];

export const GERENCIALES_REPORT_OPTIONS = [
  {
    label: 'Detalle de contratos',
    value: GERENCIALES_REPORT_TYPE,
  },
  {
    label: 'Informe de Pagos',
    value: GERENCIALES_PAYMENTS_REPORT_TYPE,
  },
  {
    label: 'Informe de Saldos de Deuda',
    value: GERENCIALES_DEBT_BALANCE_REPORT_TYPE,
  },
  // {
  //   label: 'Informe de Mora por Estado',
  //   value: GERENCIALES_DEBT_STATUS_REPORT_TYPE,
  // },
  // {
  //   label: 'Datos personales de Clientes',
  //   value: GERENCIALES_PERSONAL_DATA_REPORT_TYPE,
  // },
];

export const PIE_ALLOWED_COLORS = ['#1e88e5', '#2e7d32', '#000000', '#e3e300', '#d32f2f', '#e29b00', '#00c5b2'];

export const CHART_COLORS = {
  feeType: PIE_ALLOWED_COLORS,
  possession: PIE_ALLOWED_COLORS,
  clientType: PIE_ALLOWED_COLORS,
  feeTypePossession: PIE_ALLOWED_COLORS,
  clientTypePossession: PIE_ALLOWED_COLORS,
};

export const GERENCIALES_MESSAGES = {
  ERROR: {
    DATES_REQUIRED: 'Debe ingresar Fecha Desde y Fecha Hasta.',
    INVALID_RANGE: 'La fecha desde no puede ser mayor que la fecha hasta.',
  },
};

export const GERENCIALES_DEBT_STATUS_OPTIONS = [
  'Moroso',
  'En negociación',
  'Acuerdo vigente',
  'En revisión',
];

export const GERENCIALES_DEBT_STATUS_POSSESSOR_OPTIONS = [
  { label: 'Todos', value: 'all' },
  { label: 'Poseedor', value: 'true' },
  { label: 'No poseedor', value: 'false' },
];

export const GERENCIALES_DEBT_STATUS_ORDER_OPTIONS = [
  { label: 'Importe mora ⬇', value: 'importe_mora_desc' },
  { label: 'Importe mora ⬆', value: 'importe_mora_asc' },
  { label: 'Cupones en mora ⬇', value: 'cupones_mora_desc' },
  { label: 'Cupones en mora ⬆', value: 'cupones_mora_asc' },
  { label: 'Num. contrato ⬆', value: 'contract_number_asc' },
  { label: 'Num. contrato ⬇', value: 'contract_number_desc' },
];

export const GERENCIALES_DEBT_STATUS_VIEW_OPTIONS = [
  { label: 'Tabla', value: GERENCIALES_DEBT_STATUS_VIEW_TABLE },
  { label: 'Gráfico', value: GERENCIALES_DEBT_STATUS_VIEW_CHART },
];
